$(document.body).on('change', '.autosubmit', function () {
    $(this).closest('form').submit();
})
$(document.body).on('click', '[data-action="clear-query"]', function () {
    $(this.form).find('[name="query"]').val('');
    this.form.submit()
})

//dynamic textarea height
$(document.body).on('click', ".estimate-data-row textarea", function () {
    $(this).on('input', function () {
        $(this).height(1);
        var totalHeight = $(this).prop('scrollHeight') - parseInt($(this).css('padding-top')) - parseInt($(this).css('padding-bottom'));
        $(this).height(totalHeight);
    });
});